import React, { useEffect, useRef } from "react";

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  indeterminate?: boolean;
  disabled?: boolean;
  error?: boolean;
  className?: string;
  checkBoxSize?: string;
  disabledClassName?: string;
  checkClassName?: string;
  checkBoxClassName?: string;
  checkSize?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  indeterminate = false,
  disabled = false,
  error = false,
  className,
  checkBoxSize = "w-4 h-4",
  disabledClassName = "opacity-50",
  checkClassName = "text-text-primary",
  checkBoxClassName = "peer-checked:border-text-primary",
  checkSize = "w-3 h-3",
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const handleChange = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <label
      className={`relative flex items-center justify-center cursor-pointer rounded-full p-2 ${
        disabled ? `${disabledClassName} cursor-not-allowed` : ""
      } ${className}`}
    >
      <input
        ref={inputRef}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={`peer hidden ${error ? "border-red-500" : ""}`}
      />

      <div
        className={`${checkBoxClassName} rounded border border-gray-300 ${checkBoxSize} flex items-center justify-center transition-all duration-300
          ${disabled ? `${disabledClassName} cursor-not-allowed` : ""}
          ${error ? "border-red-500" : ""}
        `}
      >
        <svg
          className={`${checkSize} ${checkClassName} ${checked && !indeterminate ? "block" : "hidden"}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z"
            clipRule="evenodd"
          />
        </svg>

        <svg
          className={`${checkSize} ${checkClassName} ${indeterminate ? "block" : "hidden"}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <rect x="4" y="9" width="12" height="2" rx="1" />
        </svg>
      </div>
    </label>
  );
};

export default Checkbox;
